import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * @element portal-kustomer-chat
 *
 */
@customElement('portal-kustomer-chat')
export class PortalKustomerChatComponent extends LitElement {
  static styles = css`
    :host {
      display: contents;
    }
    button {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background: none;
      border: 0;
      display: inline-flex;
      cursor: pointer;
      transition: transform 0.125s ease;
    }
    button svg {
      border-radius: 50%;
    }
    button svg path {
      fill: #fff;
    }
    button svg > path:nth-child(2) {
      stroke: #fff;
    }

    @media (min-width: 767px) {
      :host {
        position: fixed;
        bottom: 80px;
        right: 110px;
        z-index: 999;
      }
      button svg > path:nth-child(3) {
        fill: var(--color-primary);
      }
      button svg > path:nth-child(2) {
        stroke: #dadada;
      }
      button:hover {
        transform: scale(1.1);
      }
      button:hover > svg {
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      }
    }
  `;

  connectedCallback(): void {
    super.connectedCallback();
    const script = document.createElement('script');
    script.src = 'https://cdn.kustomerapp.com/chat-web/widget.js';
    script.setAttribute(
      'data-kustomer-api-key',
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVmN2YyNDBmYTQxMzRlMDA5NjlhNTBiMSIsInVzZXIiOiI1ZjdmMjQwZjk3YTdkMzYwMmFlMzAwODciLCJvcmciOiI1ZjZiZTRiYWFjMWI1NzAwMWEzOTRmMzEiLCJvcmdOYW1lIjoia2luIiwidXNlclR5cGUiOiJtYWNoaW5lIiwicG9kIjoicHJvZDEiLCJyb2xlcyI6WyJvcmcudHJhY2tpbmciXSwiYXVkIjoidXJuOmNvbnN1bWVyIiwiaXNzIjoidXJuOmFwaSIsInN1YiI6IjVmN2YyNDBmOTdhN2QzNjAyYWUzMDA4NyJ9.rb5EFsCvPArF8qQ8uVFBDc5Z3-8ATygUncd_30zCSpA'
    );
    this.insertAdjacentElement('afterend', script);
    window.addEventListener('kustomerLoaded', () => {
      Kustomer.start({ hideChatIcon: true });
    });
  }

  private startChat() {
    console.log('click');
    Kustomer.open();
  }

  render() {
    return html`<button @click=${this.startChat} id="startChatButton">
      <svg
        width="55"
        height="55"
        viewBox="0 0 51 51"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.5039 1C39.037 1 50.0078 11.9708 50.0078 25.5039C50.0078 39.037 39.037 50.0078 25.5039 50.0078C11.9708 50.0078 1 39.037 1 25.5039C1.00001 11.9708 11.9708 1.00001 25.5039 1Z"
          fill="white"
        />
        <path
          d="M25.5039 1C39.037 1 50.0078 11.9708 50.0078 25.5039C50.0078 39.037 39.037 50.0078 25.5039 50.0078C11.9708 50.0078 1 39.037 1 25.5039C1.00001 11.9708 11.9708 1.00001 25.5039 1Z"
          stroke="#DADADA"
          stroke-width="2"
        />
        <path
          d="M21.9 33.0079C23.8086 33.9869 26.0041 34.2521 28.0909 33.7556C30.1777 33.2592 32.0186 32.0337 33.2818 30.3C34.545 28.5664 35.1474 26.4386 34.9806 24.3C34.8137 22.1615 33.8886 20.1528 32.3718 18.6361C30.855 17.1193 28.8464 16.1941 26.7078 16.0273C24.5693 15.8604 22.4415 16.4629 20.7078 17.7261C18.9742 18.9893 17.7487 20.8302 17.2522 22.917C16.7558 25.0038 17.0209 27.1993 18 29.1079L16 35.0079L21.9 33.0079Z"
          fill="#FFC857"
          stroke="#12120F"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'portal-kustomer-chat': PortalKustomerChatComponent;
  }
}
